/**
 * BackendDashboardTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendDashboard} from "./BackendDashboard";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendDashboardTag extends TagAbstract {
    /**
     * Returns all available dashboard widgets
     *
     * @returns {Promise<BackendDashboard>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(): Promise<BackendDashboard> {
        const url = this.parser.url('/backend/dashboard', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendDashboard;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
